// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62b0287a","455":"e352341a"}[chunkId] + ".chunk.js";
};